module.exports = __webpack_public_path__ + "img/line3.5684d0dd.svg";